import { Component, Input, OnInit } from '@angular/core';
import { AuthService, UserRole, CurrentUser } from '../../services/auth.service';

export interface NavItem {
  label: string;
  route: string;
  icon: string;
  exact?: boolean;
  roles: UserRole[];
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

const NAV_CONFIG: NavGroup[] = [
  {
    label: 'Main',
    items: [
      { label: 'Dashboard', route: '/app/dashboard', icon: 'dashboard', exact: true, roles: ['super_admin', 'admin', 'manager', 'viewer'] }
    ]
  },
  {
    label: 'Management',
    items: [
      { label: 'Location Management',     route: '/app/locations', icon: 'location',  roles: ['super_admin', 'admin', 'manager'] },
      { label: 'Equipment Management',    route: '/app/equipment', icon: 'equipment', roles: ['super_admin', 'admin', 'manager'] },
      { label: 'File Management',         route: '/app/files',     icon: 'file',      roles: ['super_admin', 'admin', 'manager', 'viewer'] },
      { label: 'Schedule Management',     route: '/app/schedules', icon: 'schedule',  roles: ['super_admin', 'admin', 'manager'] },
      { label: 'Digital Signage Display', route: '/app/displays',  icon: 'display',   roles: ['super_admin', 'admin', 'manager', 'viewer'] },
      { label: 'Signage Editor',          route: '/app/editor',    icon: 'editor',    roles: ['super_admin', 'admin', 'manager'] }
    ]
  },
  {
    label: 'System',
    items: [
      { label: 'User Management', route: '/app/users',    icon: 'users',    roles: ['super_admin', 'admin'] },
      { label: 'Settings',        route: '/app/settings', icon: 'settings', roles: ['super_admin', 'admin'] }
    ]
  }
];

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css'
})
export class SidenavComponent implements OnInit {
  @Input() collapsed = false;

  navGroups: NavGroup[] = [];
  user!: CurrentUser;

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    this.user = this.auth.getUser();
    const role = this.auth.getRole();
    this.navGroups = NAV_CONFIG
      .map(g => ({ ...g, items: g.items.filter(i => i.roles.includes(role)) }))
      .filter(g => g.items.length > 0);
  }
}
